<div class="content center p-l p-r p-t-20 p-t-10-s">
    <h1 sizeClass="S: h2, !S: h1"

        *iCms="'mainTitle' of content"
        text></h1>
    <p class="m-t-5 m-t-0-s col-11"
       sizeClass="S: p2, !S: p1">
        {{'Your order number is' | translate}}: #{{data.number}}
    </p>

    <p class="m-t-10 m-t-5-s s1"

       *iCms="'subtitle' of content"
       text></p>

    <p class="m-t-2"
       sizeClass="S: p2, !S: p1"

       *iCms="'copy' of content; content: 'html'"
       ></p>

    <a routerLink="/"
       class="button m-t-10 m-t-6-s w-11-s">
        <span
              class="p1"
              *iCms="'continueButtonCopy' of content"
              text></span>
    </a>
</div>

<icms-outlet
             [components]="content?.bottomComponents">
</icms-outlet>